/**
 * @file audio-track-menu-item.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _menuMenuItemJs = require('../../menu/menu-item.js');

var _menuMenuItemJs2 = _interopRequireDefault(_menuMenuItemJs);

var _componentJs = require('../../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _utilsFnJs = require('../../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

/**
 * The audio track menu item
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuItem
 * @class AudioTrackMenuItem
 */

var AudioTrackMenuItem = (function (_MenuItem) {
  _inherits(AudioTrackMenuItem, _MenuItem);

  function AudioTrackMenuItem(player, options) {
    var _this = this;

    _classCallCheck(this, AudioTrackMenuItem);

    var track = options.track;
    var tracks = player.audioTracks();

    // Modify options for parent MenuItem class's init.
    options.label = track.label || track.language || 'Unknown';
    options.selected = track.enabled;

    _MenuItem.call(this, player, options);

    this.track = track;

    if (tracks) {
      (function () {
        var changeHandler = Fn.bind(_this, _this.handleTracksChange);

        tracks.addEventListener('change', changeHandler);
        _this.on('dispose', function () {
          tracks.removeEventListener('change', changeHandler);
        });
      })();
    }
  }

  /**
   * Handle click on audio track
   *
   * @method handleClick
   */

  AudioTrackMenuItem.prototype.handleClick = function handleClick(event) {
    var tracks = this.player_.audioTracks();

    _MenuItem.prototype.handleClick.call(this, event);

    if (!tracks) return;

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      if (track === this.track) {
        track.enabled = true;
      }
    }
  };

  /**
   * Handle audio track change
   *
   * @method handleTracksChange
   */

  AudioTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
    this.selected(this.track.enabled);
  };

  return AudioTrackMenuItem;
})(_menuMenuItemJs2['default']);

_componentJs2['default'].registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
exports['default'] = AudioTrackMenuItem;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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